import moment from 'moment'

export function formatDateString (field) {
  if (field.value == null) {
    return 'Not Specified'
  } else {
    return moment(field.value).format('LLLL')
  }
}



// WEBPACK FOOTER //
// ./src/components/formatters/dateFormatter.js